import { http } from '@/lib/http';
import { createHttpClient, postDrawLotsFromCampaign as postDrawLotsFromCampaignCommon } from '@monorepo/common';

export type { PostDrawCampaignParams, PostDrawCampaignResponse } from '@monorepo/common';

export const postDrawLotsFromCampaign = async (params: { lotteryEventBranchId: number; serialCode: string }) => {
  const httpClient = createHttpClient(http);
  return await postDrawLotsFromCampaignCommon(params, httpClient);
};
